import { InputTextarea, InputTextareaProps } from 'primereact/inputtextarea';
import React from 'react';
import CharacterCounter from '../CharacterCounter/CharacterCounter';

export type AppTextareaProps = Omit<InputTextareaProps, 'label'> & {
  label?: string;
  error?: string;
  maxLength?: number;
  showCharCounter?: boolean;
};

const AppTextarea: React.FC<AppTextareaProps> = ({
  label,
  error,
  required,
  maxLength,
  showCharCounter,
  ...props
}) => {
  const currentLength = typeof props.value === 'string' ? props.value.length : 0;

  return (
    <div className="flex flex-col w-full">
      {label && (
        <label className="label-text">
          {label} {required && <span className="p-error">*</span>}
        </label>
      )}
      <InputTextarea {...props} maxLength={maxLength} />
      {showCharCounter && maxLength && <CharacterCounter current={currentLength} max={maxLength} />}
      {error && <small className="p-error">{error}</small>}
    </div>
  );
};

export default AppTextarea;
